import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PartnerHero from './components/PartnerHero';
import PartnerResell from './components/PartnerResell';
import PartnerWhoFor from './components/PartnerWhoFor';
import PartnerHowWorks from './components/PartnerHowWorks';
import PartnerBenefits from './components/PartnerBenefits';
import PartnerCTA from './components/PartnerCTA';
import PartnerFAQ from './components/PartnerFAQ';

export default function PartnerProgram() {
  return (
    <main>
      <Navbar />

      <PartnerHero />

      <PartnerResell />

      <PartnerWhoFor />

      <PartnerHowWorks />

      <PartnerBenefits />

      <PartnerCTA />

      <PartnerFAQ />

      <Footer />
    </main>
  );
}